import { atom } from 'jotai'
import type { Getter } from 'jotai'
import type { TrasparenzaResponse } from './defaultReducerState'

//import type { State } from '@store/defaultReducerState'
const stepStart = 1 //for single step test

export const STORAGE_KEY = 'simulatore_to_richiesta'
export const RICHIESTA_TO_SIM_KEY = 'richiesta_to_simulatore'


//trasparenza 

export const trasparenzaAtom = atom<TrasparenzaResponse | null>(null)
export const trasparenzaCodeAtom = atom<string | null>(null)
export const trasparenzaRefreshKeyAtom =atom<string | null>(null)

export const silentFetches = atom(0)

// Radio button principale → stringa

export const selectedValueAtom = atom<Record<number, string>>({})

// Substep → stringa (valore selezionato del substep)
export const selectedSubStepAtom = atom<string>('')

export const showSubStepAtom = atom<Record<number, boolean>>({})

// SubStepExists → booleano (true se la categoria selezionata ha substeps)
export const subStepExistsAtom = atom<boolean>(false)

// Step attivo dello stepper → numero
export const activedStep = atom<number>(stepStart) //USATO QUESTO PER IL 4.4 SIMULATORE

export const activedSubStep = atom<number>(0) //USATO QUESTO PER IL 4.4


///codice promoziomale inserito 
export const promotionalCodeAtom = atom<string>('')
// Derived: true when a confirmed promo code is present
export const promotionalCodeValidAtom = atom((get) => get(promotionalCodeAtom) !== '')

// Logo URL returned by GetAzAffinity for the active affinity code
export const affinityLogoAtom = atom<string | null>(null)


export const emailUserAtom = atom<string>('')

//valore del prestio richiesto sabile
export const stableAmountAtom = atom<string>((get: Getter) => {
	const amountValue = get(formDataAtom).amount?.value
	return amountValue ?? '0' // default string
})

// Tiene traccia dell'ultimo amount per cui è stata fatta la chiamata
export const lastFetchedAmountAtom = atom<string | null>(null)

// IDEM PER INSURANCE
export const lastFetchedInsuranceInstallmentAtom = atom<number | null>(null)

export type Installment = {
	InstallmentsCount: number
	Amount: number
	Tan: number
	Taeg: number
	PrgSimul: number
	Erogato: number
	FinanziamLordo: number
	ImpServiziFinanz: number
	ImpServiziFinanzOLD: number
	ImpServiziIdentinet: number
	Interessi: number
	Rendiconto:number
	Dovuto:number
	Bollo  :number
	Istruttoria:number
	SpeseGestPrat:number
}

export type LoanInstallments = {
	id: string
	Installments: Installment[]
	CocalfinID: number
	WrongCode: boolean
	FinancialTable: string
	TipoProdotto: string
	Prodotto: string
	Provenienza: string
	Emettitore: string
	FinancialTablFT: string | null
	TipoProdottoFT: string | null
	ProdottoFT: string | null
	ProvenienzaFT: string | null
	EmettitoreFT: string | null
	SelectedInstallment: Installment | null
	sessione: string | null
}

type Option = {
	value: string
	label?: string
	tabFin?:string
}

export type DataSimulatore = {
	category: Option | null
	subCategory: Option | null
	subCategorylabel :string | null 
	amount: Option | null
	selectedInstallment: Installment | null
	installments: LoanInstallments | null
	installmentsSond: LoanInstallments | null
	selectedInstallmentSond: Installment | null
	insurance: Option | null
	offer: Option | null
	email: string | null
	codicePromozionale:string | null
	disclaimer:string | null
}

//QUESTO è IL MODEL DEL SIMULATORE
export const formDataAtom = atom<DataSimulatore>({
	category: null,
	subCategory: null,
	subCategorylabel:null,
	amount: null,
	selectedInstallment: null,
	installments: null,
	selectedInstallmentSond: null,
	installmentsSond:null,
	insurance: null,
	offer: null,
	email: null,
	codicePromozionale:null,
	disclaimer:null
})

export const CATEGORY = 'category' as const
export const SUB_CATEGORY = 'subCategory' as const
export const SUB_CATEGORY_LABEL = 'subCategorylabel' as const
export const AMOUNT = 'amount' as const
export const RATE = 'selectedInstallment' as const
export const INSURANCE = 'insurance' as const
export const OFFER = 'offer' as const
export const DISCLAIMER = 'disclaimer' as const


export const EMPTY = '' as const

export const sessioneAtom = atom<string | null>(null)
export const mobileTokenAtom = atom<string | null>(null)
export const currentStepAtom = atom<number>(0)
export const richiestaIdAtom = atom<number | null>(null)

export const MAX = 30000
export const MIN = 1500

export const INSURANCE_YES = "1";
export const INSURANCE_NO = "2";



export const ModuleType = {
  SIMULATORE: 1,
  PREVENTIVATORE: 2,

} as const

export const ProvenienzaMap={
	SIMULATORE:'SIMULATORE',
	COMPARATORE:'COMPARATORE'
}


 export const sbTokenFallback = 'zDneXrUvQV_bJM1Lgeiai-By0JspeYA1KQLlvEdzeex3n4uoPDlj2KkTzUrbrH26'


export const disclaimerOpenAtom = atom(true)


export const MOBILE_QR_START_URL_KEY = 'mobile_qr_start_url'

export const MOBILE_QR_ACTIVE_KEY = 'mobile_qr_active'